module.exports = __webpack_public_path__ + "img/SWP_Staff_2H_03 (1).8573d394.png";